var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:navigation-16-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.69769 5.625C3.69769 5.32663 3.81747 5.04048 4.03068 4.8295C4.24389 4.61853 4.53306 4.5 4.83459 4.5H20.7511C21.0526 4.5 21.3418 4.61853 21.555 4.8295C21.7682 5.04048 21.888 5.32663 21.888 5.625C21.888 5.92337 21.7682 6.20952 21.555 6.4205C21.3418 6.63147 21.0526 6.75 20.7511 6.75H4.83459C4.53306 6.75 4.24389 6.63147 4.03068 6.4205C3.81747 6.20952 3.69769 5.92337 3.69769 5.625ZM3.69769 11.625C3.69769 11.3266 3.81747 11.0405 4.03068 10.8295C4.24389 10.6185 4.53306 10.5 4.83459 10.5H20.7511C21.0526 10.5 21.3418 10.6185 21.555 10.8295C21.7682 11.0405 21.888 11.3266 21.888 11.625C21.888 11.9234 21.7682 12.2095 21.555 12.4205C21.3418 12.6315 21.0526 12.75 20.7511 12.75H4.83459C4.53306 12.75 4.24389 12.6315 4.03068 12.4205C3.81747 12.2095 3.69769 11.9234 3.69769 11.625ZM3.69769 17.625C3.69769 17.3266 3.81747 17.0405 4.03068 16.8295C4.24389 16.6185 4.53306 16.5 4.83459 16.5H20.7511C21.0526 16.5 21.3418 16.6185 21.555 16.8295C21.7682 17.0405 21.888 17.3266 21.888 17.625C21.888 17.9234 21.7682 18.2095 21.555 18.4205C21.3418 18.6315 21.0526 18.75 20.7511 18.75H4.83459C4.53306 18.75 4.24389 18.6315 4.03068 18.4205C3.81747 18.2095 3.69769 17.9234 3.69769 17.625Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.d94fd55e44f78477ef3050ebd56e74e7.svg";
export { ForwardRef as ReactComponent };